import { useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { axiosInstance } from '@/lib/axios'

type Props = {
  companyId: string | undefined
  enabled?: boolean
}

/** Kierowca przypięty do zalogowanego użytkownika w firmie; null, gdy konto nie ma kierowcy. */
export function useQueryCurrentUserDriverId({
  companyId,
  enabled = true,
}: Props) {
  return useQuery<number | null>({
    queryKey: ['driver', 'currentUser', String(companyId)],
    enabled: enabled && !!companyId,
    staleTime: MINUTE_IN_MS * 5,
    queryFn: async () => {
      const res = await axiosInstance.get(
        `api/${companyId}/driver/GetDriverIdForCurrentUser?companyId=${companyId}`,
      )
      return typeof res.data === 'number' ? res.data : null
    },
  })
}
